import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/sessionTimerGradient.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-1485fdfa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "popup-overlay"
}
const _hoisted_2 = { class: "popup card" }
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = {
  key: 0,
  class: "p-2 font-opensans font-semibold text-base"
}
const _hoisted_5 = {
  key: 1,
  class: "font-opensans font-semibold text-sm"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-b border-solid border-lightgrey mt-2" }, null, -1))
const _hoisted_7 = { class: "flex pt-3 gap-5" }
const _hoisted_8 = { class: "mainSession" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "sessionTimer"
}, null, -1))
const _hoisted_10 = { class: "font-opensans" }
const _hoisted_11 = { class: "contentOfSession flex flex-col justify-center" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sessionText open-sans" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Click "),
    /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-black textSize font-opensans px-1" }, "\"Extend Session\""),
    /*#__PURE__*/_createTextVNode(" to keep working. ")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("Click"),
    /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-black textSize font-opensans px-1" }, "\"Logout\""),
    /*#__PURE__*/_createTextVNode(" to end your session now.")
  ])
], -1))
const _hoisted_13 = { class: "flex buttonStyling" }
const _hoisted_14 = { class: "flex items-end" }
const _hoisted_15 = { class: "flex items-end" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.showPopup)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.formattedRemainingTime === 'Session Expired')
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Time Out!!"))
              : (_openBlock(), _createElementBlock("p", _hoisted_5, "Your Session is Expiring Soon!!"))
          ]),
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.formattedRemainingTime), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "extendSessionButton filterButton widthForLogout",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
                  }, " Logout Now ")
                ]),
                _createElementVNode("div", _hoisted_15, [
                  (_ctx.formattedRemainingTime !== 'Session Expired')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "filterButton buttonposition",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.extendSession && _ctx.extendSession(...args)))
                      }, " Extend Session "))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _hoisted_16
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}